import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    placeholder: String,
  };

  connect() {
    this.setupGoogle();
  }

  setupGoogle() {
    // GoogleAPI is loaded with defer/async, so wait until it's ready
    if (this.googlePresent) {
      this.setupAutocomplete();
    } else {
      setTimeout(() => this.setupGoogle(), 500);
    }
  }

  setupAutocomplete() {
    this.element.placeholder = this.placeholderValue;
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.element,
      {
        types: ['geocode'],
      },
    );

    if (this.element.required) {
      this.event_place_changed = window.google.maps.event.addListener(
        this.autocomplete,
        'place_changed',
        () => {
          const place = this.autocomplete.getPlace();
          if (place.geometry) {
            this.element.setCustomValidity('');
          } else {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
          }

          // Send "input" event to element, so FormsController can react on this
          const event = document.createEvent('Event');
          event.initEvent('input', true, true);
          this.element.dispatchEvent(event);
        },
      );

      this.event_keydown = window.google.maps.event.addDomListener(
        this.element,
        'keypress',
        (e) => {
          // Every keypress except ENTER makes the input invalid
          if (e.which !== 13) {
            this.element.setCustomValidity('Wähle einen Ort aus.');
          }
        },
      );
    }
  }

  disconnect() {
    if (this.googlePresent && this.autocomplete) {
      window.google.maps.event.clearInstanceListeners(this.autocomplete);
    }
  }

  get googlePresent() {
    return typeof window.google !== 'undefined';
  }
}
